<template>
  <div class="wechat_box">
    <div class="left right">
      <div class="title">使用平台已绑定的公众号</div>
      <h2>我有自营的公众号，且满足下列条件，我要绑定<br />自己的微信公众号。</h2>
      <div class="mode">
        <div class="icon"><i class="iconfont icon-fuwuhao first"></i></div>
        <div class="text">微信公众号类型是服务号<br />
          <span>访问微信公众平台</span> <a href="https://mp.weixin.qq.com"> https://mp.weixin.qq.com</a>
        </div>
      </div>
      <!--  -->
      <div class="mode">
        <div class="icon"><i class="iconfont icon-renzheng second"></i></div>
        <div class="text">微信公众号已经申请了微信认证<br />
          <span>此过程中需要银行账号</span>
        </div>
      </div>
      <!--  -->
      <div class="mode">
        <div class="icon"><i class="iconfont icon-weixinzhifu third"></i></div>
        <div class="text">已开通微信支付（微信商户平台）<br />
          <span>访问微信商户平台</span> <a href="https://pay.weixin.qq.com"> https://pay.weixin.qq.com</a>
        </div>
      </div>
      <!--  -->
      <div class="word">绑定时请使用微信公众号注册手机扫描二维码</div>
      <a class="lookMore less" target="_blank" href="http://files.xcharger.net/%E6%99%BA%E5%85%85%E4%BA%A7%E5%93%81/03-%E8%BF%90%E8%90%A5%E5%95%86%E5%B9%B3%E5%8F%B0/05-%E4%BB%8B%E7%BB%8D/%E5%A6%82%E4%BD%95%E6%B3%A8%E5%86%8C%E8%BF%90%E8%90%A5%E5%95%86.html">获取更多帮助</a>
      <div class="tip">
        <iframe :src='bindWxUrl' width='130' height='36' frameborder='no' border='no' marginwidth='0' marginheight='0' scrolling='no' allowtransparency='yes' class="iframe"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {
  requestUrl,
  ajax,
  checkLogin,
  getQueryString,
  bindWxUrl,
} from "@/assets/utils/network";
export default {
  data() {
    return {
      bindWxUrl: "",
    };
  },
  created() {
    this.bindWxUrl = bindWxUrl;
    let num = getQueryString("alert");
    if (num != null && num != "") {
      let content = this.$parent.$t("registerEmail_40000");
      if (num == 1) {
        content = this.$parent.$t("registerEmail_40001");
      } else if (num == 2) {
        content = this.$parent.$t("registerEmail_40002");
      } else if (num == 3) {
        let wechatOASourceId = checkLogin("wechatOASourceId");
        let wechatName = "";
        if (wechatOASourceId != null) {
          ajax({
            type: "GET",
            url: requestUrl + "/wechatoa?sourceId=" + wechatOASourceId,
            dataType: "json",
            success: function (response) {
              let info = JSON.parse(response);
              wechatName = info.nickname;
            },
          });
        }
        content = this.$parent.$t("registerEmail_40003") + wechatName;
      }
      this.$alert(content, this.$parent.$t("registerEmail_40004"), {
        confirmButtonText: this.$parent.$t("registerEmail_40005"),
      });
    }
  },
  methods: {
    bindWx() {
      window.location.href = bindWxUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/font/iconfont.css";
.wechat_box {
  width: 400px;
  height: 540px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}
.left {
  width: 400px;
  height: 540px;
  border: solid 1px #e5e5e5;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;

  &:hover {
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s linear;
  }

  & .title {
    width: inherit;
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    background-color: #f4f5f5;
    border-bottom: 1px solid #e5e5e5;
    color: #333333;
    font-size: 16px;
  }

  & h2 {
    color: #999;
    font-size: 14px;
    padding-left: 20px;
    margin-top: 16px;
    font-weight: normal;
  }

  & .tip-title {
    margin-top: 100px;
    font-size: 14px;
    color: #0a1222;
    padding-left: 20px;

    span {
      color: #999;
      font-size: 12px;
    }
  }

  & .search-wechat {
    width: 360px;
    margin: 10px auto 0;
  }

  & .result-box {
    width: 360px;
    height: 100px;
    margin: 0 auto;
  }
  // 公众号查询结果
  & .search-result {
    width: 360px;
    height: 100px;
    padding-top: 10px;
    margin: 60px auto 0;
    border-radius: 4px;
    border: 1px solid #ececec;
    box-sizing: border-box;
    background: #fafdff;

    & .center-info {
      width: 340px;
      height: 80px;
      border: 1px dashed #ececec;
      border-radius: 4px;
      margin: 0 auto;

      & .icon-state {
        float: left;
        width: 20px;
        height: 80px;
        line-height: 80px;
        color: #2bdc9c;
        font-size: 18px;
        margin-left: 30px;
      }

      & .icon-img {
        float: left;
        width: 60px;
        height: 70px;
        padding-top: 10px;
        margin-left: 20px;

        & img {
          display: block;
          border: none;
          margin: 0;
          background: #999;
          width: 60px;
          height: 60px;
        }
      }

      & .name-info {
        float: left;
        width: 180px;
        height: 70px;
        font-size: 14px;
        padding-top: 10px;
        margin-left: 10px;

        & p {
          width: inherit;
          height: 30px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          & span {
            display: block;
            width: 180px;
            height: 30px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          &:nth-child(2) {
            color: #999;
          }
        }
      }
    }
  }

  & a {
    display: block;
    text-align: center;
    margin-top: 20px;
  }
  & .lookMore {
    margin-top: 70px;
    font-size: 14px;
    color: #20a0ff;
  }
  & .less {
    margin-top: 20px;
  }
  & .tip {
    margin-top: 20px;
  }
}

.right {
  & .mode {
    width: inherit;
    height: 50px;
    margin-left: 20px;
    margin-top: 28px;

    & .icon {
      float: left;
      width: 50px;
      height: 50px;
      line-height: 50px;
      text-align: center;

      & .first {
        color: #24b187;
        font-size: 38px;
      }

      & .second {
        color: #f39617;
        font-size: 38px;
      }

      & .third {
        color: #08bc07;
        font-size: 38px;
      }
    }

    & .text {
      float: left;
      line-height: 1.8;
      margin-left: 8px;
      font-size: 14px;
      color: #333;

      & span {
        font-size: 12px;
        color: #999;
      }

      & a {
        display: inline;
        color: #2081d1;
      }
    }
  }

  & .word {
    width: inherit;
    height: auto;
    line-height: 1;
    margin-top: 68px;
    color: #999;
    text-align: center;
    font-size: 12px;
  }
}
.iframe {
  display: block;
  border-radius: 4px;
  margin: 0 auto;
  cursor: pointer;
}
</style>